import React, { useContext, useEffect, useState } from "react";
import BarChart from "./BarChart";
import AuthContext from "../../../contexts/auth-context";
import useAxios from "../../../hooks/useAxios";
import { urls } from "../../config/variables";
import { validatePatientsWithExcessiveEncounterFrequency } from "../../../Utils/validateHttpResponse";
import Toastify from "../../ui/Toastify";
import { toastify_status } from "../../config/variables";
import AppContext from "../../../contexts/app-context";

const PatientsWithExcessiveEncounterFrequency = () => {
  const [data, setData] = useState([]);
  const { operation } = useAxios();
  const authCtx = useContext(AuthContext)
  const token = authCtx.token;
  const { globalFilterQuery } = useContext(AppContext);

  const fetchData = () => {
    operation(
      {
        method: 'GET',
        url: urls.PATIENTS_WITH_EXCESSIVE_ENCOUNTER_FREQUENCY + globalFilterQuery,
        headers: { Authorization: `token ${token}` },
        data: {},
      },
      handleSetData,
      handleSetDataError
    );
  }
  useEffect(() => {
      fetchData()
      // eslint-disable-next-line
  }, []);
  
  const handleSetData = (response) => {
    if (validatePatientsWithExcessiveEncounterFrequency(response)) {
      setData(response);
    } else {
      Toastify({
        message: "Invalid patients with excessive encounter frequency response data",
        state: toastify_status.ERROR,
      });
    }
  }

  const handleSetDataError = (error) => {
    console.log(error)
  }

  const xAxisData = data.map((item) => item.patient);
  const encounterCounts = data.map((item) => item.encounter_count);

  const option = {
    title: {
      text: "Patients with Frequent Encounters",
      subtext: 'Patients with 20 or more encounters',
      left: "center",
      top: 10,
      textStyle: {
        fontSize: 16,
        fontWeight: "bold",
      },
    },
    legend: {
      data: ["Encounter Count"],
      type: "scroll",
      bottom: 1,
      left: "center",
      icon: "rect",
      itemWidth: 20,
      itemHeight: 10,
      textStyle: {
        fontSize: 12,
      },
    },
    tooltip: {
      trigger: "axis",
      formatter: (params) => {
        const { name, value } = params[0];
        return `<b>${name}</b><br/>Encounters: ${value}`;
      },
    },
    xAxis: {
      type: "category",
      data: xAxisData,
      axisLabel: {
        interval: 0,
        overflow: "break",
        formatter: function (value) {
          const maxLength = 25;
          if (value.length > maxLength) {
            return value.match(new RegExp('.{1,' + maxLength + '}', 'g')).join('\n');
          }
          return value;
        },
      },
    },
    yAxis: {
      type: "value",
      name: "Encounter Count",
    },
    series: [
      {
        name: "Encounter Count",
        type: "bar",
        data: encounterCounts,
        itemStyle: {
          color: (params) =>
            params.value > 40
              ? "#E74C3C" // 🔴 red for very high frequency
              : params.value > 30
              ? "#F39C12" // 🟠 orange for moderate
              : "#3498DB", // 🔵 blue for normal
        },
        label: {
          show: true,
          position: "top",
        },
      },
    ],
    grid: {
      top: 80,
      bottom: 60,
      left: 60,
      right: 30,
    },
  };

  return (
    <BarChart
      name="Patients With Excessive Encounter Frequency"
      option={option}
      dataLength={data.length}
    />
  );
};

export default PatientsWithExcessiveEncounterFrequency;
